import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const modifyPromoCodeActiveStatus = async (
  id: string,
  isPromoCodeActive: boolean
) => {
  const res = await apiManager.patch(`/admin/promoCode/${id}/togglePromoCode`, {
    isPromoCodeActive,
  });
  return res;
};

export const useModifyPromoCodeActiveStatus = () =>
  useMutation({
    mutationFn: async ({ id, isPromoCodeActive }: { id: string; isPromoCodeActive: boolean }) => {
      const res = await apiClient.patch(ENDPOINTS.PROMO_CODES.MODIFY_PROMO_CODE(id), { isPromoCodeActive });
      return res.data;
    },
  });